import { FC, ReactNode } from 'react';
import classNames from 'classnames';

import { COLORS } from 'consts';
import { StyledComponent } from 'types';
import { noop } from 'utils/noop';

export const ActionButtonTestIds = {
  container: 'action-button-container'
};

export type ActionButtonProps = {
  type?: 'primary' | 'secondary' | 'pink';
  onClick: () => void;
  content: ReactNode;
  disabled?: boolean;
} & StyledComponent;

export const ActionButton: FC<ActionButtonProps> = ({
  type = 'primary',
  content,
  onClick,
  className,
  disabled,
  style
}) => {
  let bgColor = COLORS.turquoise;

  if (disabled) {
    bgColor = '#a5a5a4';
  } else if (type === 'secondary') {
    bgColor = 'rgba(255, 252, 249, 0.04)';
  } else if (type === 'pink') {
    bgColor = COLORS.pink;
  }

  return (
    <div
      data-testid={ActionButtonTestIds.container}
      role='button'
      style={{
        backgroundColor: bgColor,
        pointerEvents: disabled ? 'none' : 'auto',
        height: '56px',
        ...style
      }}
      className={classNames('riforma-medium py-3 mt-2 border-radius-16', className, {
        'text-primary': type === 'primary' || disabled,
        'text-light': type === 'secondary'
      })}
      onClick={disabled ? noop : onClick}
    >
      {content}
    </div>
  );
};
